import '../css/module_landing.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import {doLast} from './module_last';
import { initFirebaseApp } from './module_firebase';
import { 
    handleUserLoginWithCallbackNoPremium,
    manageLogin, 
    openModalAndGotoUrl, 
    openSignUpAndGotoUrl,
    setRedirectAfterLogin,
 } from './module_auth_helper';
import {
    frontendSubscribeLink,
    updateBuyButtonCta,
    alternativeCheckoutLink,
    manageWelcomeGuestPremium,
    showSpinner,
    hideSpinner,
    alertNotification,
    sentryAPIErrorV2,
    protectedApiCallRetry,
    signinModalId,
    premiumSubscribeMsg,
    successNotification,
} from './module_common';

import { initNavbar } from './module_header';

import {
    defaultCarouselSetupVisitor,
} from './module_swiper_visitor';

import {configSkillBooksCarousel} from './module_skill-books-carousel';
import { initCardLazyLoad } from './module_lazyload';

import './module_common_actions';
import { doNotRedirectToProfileOnProblemSendingEmailModalClose, getThankyoupageUrl } from './module_checkout_helper';
import { handleOfferTimer } from './module_landing_offer_common';

const ctaButtonSelector = ".cta-button-attach-clk"

class LandingPageError extends Error {
    constructor(...params) {
        super(...params);
        this.name = "LandingPageError"
    }
}

let isLogged = false
let isPremium = false

function setLogged(){
    isLogged = true
}

function setPremium(){
    isPremium = true
}

async function handleStartFreemium(){ 
    showSpinner()

    let url = `/users/${UIDg}/freemium_request`
    if (icAttr !== ''){
        url += '?tag='+icAttr
    }
    let freemiumResponse
    try {
        freemiumResponse = await protectedApiCallRetry('POST', url, {}, 3)
    } catch (error) {
        hideSpinner()
        alertNotification(genericRetryErrMsg)
        const err = new LandingPageError("Error during freemium call", {cause: error})
        const contextData = {data: {user_id: uid}}
        sentryAPIErrorV2(err, contextData)
        return
    }
    hideSpinner()
    let redUrl = getThankyoupageUrl()
    if (!redUrl) redUrl = "/"+LL

    window.location = redUrl
}

function manageBuyButtonClick(){
    // icf (IsCustomFreemium) and icAttr defined in html template
    if(typeof icf != 'undefined' && typeof icAttr != 'undefined' && icf){
        // maybe from previous login 
        if(isLogged){
            if (isPremium){
                successNotification(premiumSubscribeMsg)
            }else{
                handleStartFreemium()
            }
        }else{
            setRedirectAfterLogin(false)
            doNotRedirectToProfileOnProblemSendingEmailModalClose()
            const loginHandler = handleUserLoginWithCallbackNoPremium(
                handleStartFreemium,
                premiumSubscribeMsg,
                setLogged,
                setPremium
            )
            document.body.addEventListener("userLogged", loginHandler)
            // dont use openSignInModal, there might be some logic 
            // to changing the login flow
            openModalAndGotoUrl(signinModalId)
        }
    }else if (alternativeCheckoutLink){
        window.location = frontendSubscribeLink
    }else{
        openSignUpAndGotoUrl(frontendSubscribeLink)
    }
}

const mostViewedCarouselSetUp = function(){
    const out = "mostviewed-out"
    const container = "mostviewed-swiper-container"
    defaultCarouselSetupVisitor(container, out, 'auto', 4, 4, 6)
}

const attachCtaButtonClick = function (){
    $(ctaButtonSelector).on('click', function(e){
        manageBuyButtonClick()
    })
}

function attachHeaderBuyButtonClick(){
    $('.header-subscribe-btn-attach-clk').on('click', function(e){
        manageBuyButtonClick()
    })
}

function attachBuyButtonClick(){
    $('.buy-btn-attach-clk').on('click', function(e){
        manageBuyButtonClick()
    })
}

$(function () {
    initFirebaseApp()
    manageLogin()
    
    // do it after do_last call
    manageWelcomeGuestPremium()
    
    doLast();
    
    initNavbar()

    handleOfferTimer()

    initCardLazyLoad()

    configSkillBooksCarousel()
    mostViewedCarouselSetUp()

    attachCtaButtonClick()
    attachHeaderBuyButtonClick()
    attachBuyButtonClick()

    // buttonsCta eventuallly defined in twig template
    if (typeof buttonsCta !== 'undefined'){
        updateBuyButtonCta(buttonsCta)
    }
});